/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const ParticipantIcon1 = ({ className }) => {
  return (
    <svg
      className={`uporabnik-icon-1 ${className}`}
      fill="none"
      height="40"
      viewBox="0 0 41 40"
      width="41"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        className="rect"
        fill="#00BABD"
        height="40"
        rx="5"
        width="40"
        x="0.299805"
      />
      <path
        className="path"
        d="M28.2998 29V27C28.2998 25.9391 27.8784 24.9217 27.1282 24.1716C26.3781 23.4214 25.3607 23 24.2998 23H16.2998C15.2389 23 14.2215 23.4214 13.4714 24.1716C12.7212 24.9217 12.2998 25.9391 12.2998 27V29"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        className="path"
        d="M20.2998 19C22.5089 19 24.2998 17.2091 24.2998 15C24.2998 12.7909 22.5089 11 20.2998 11C18.0907 11 16.2998 12.7909 16.2998 15C16.2998 17.2091 18.0907 19 20.2998 19Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
};
